import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class AnswerBlockPhysics extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, x, y) {
    super(scene, x, y);

    this.setup();
  }

  setup () {
    /** @type {Phaser.GameObjects.Image[]} */
    this.blocks = [];
    const blockCount = 4;
    for (let i = 0; i < blockCount; i++) {
      const item = ABCyaPhaser.Images.addImage(0,0,'question_box', this);
      this.boxHalfWidth = item.width / 2;
      this.boxHalfHeight = item.height / 2;
      this.scene.physics.add.existing(item);
      item.body.checkCollision.up = true;
      item.body.checkCollision.left = false;
      item.body.checkCollision.right = false;
      item.body.checkCollision.down = false;
      item.setActive(false).setVisible(false);
      item.body.enable = false;
      this.blocks.push(item);
    }

    this.collidesPlayer = false;
  }

  positionAndActivate (locs, selectedIndex, wasCorrect) {
    for (let i = 0; i < this.blocks.length; i++) {
      const item = this.blocks[i];

      item.setPosition(locs[i].x + this.boxHalfWidth, locs[i].y + this.boxHalfHeight).setActive(true)
        .setVisible(true);
      item.body.enable = true;
      item.body.reset(item.x, item.y);
      if (wasCorrect || i === selectedIndex) {
        item.body.moves = false;
        item.body.checkCollision.up = true;
        item.body.checkCollision.left = false;
        item.body.checkCollision.right = false;
        item.body.checkCollision.down = false;
      }
    }
    this.collidesPlayer = true;
  }

  collapse() {
    for (let i = 0; i < this.blocks.length; i++) {
      const item = this.blocks[i];
      item.body.moves = false;
      item.body.gravity.y = 280;
      item.body.velocity.y = 10;
      item.body.moves = true;
      item.body.checkCollision.up = true;
      item.body.checkCollision.left = true;
      item.body.checkCollision.right = true;
      item.body.checkCollision.down = true;
    }
  }

  deactivate () {
    for (let i = 0; i < this.blocks.length; i++) {
      this.blocks[i].setActive(false).setVisible(false);
      this.blocks[i].body.enable = false;
    }
  }
}